import type { DmPrinter, DmDetectedPrinters, DMSupportedPrinter } from '@nsftx/systems-sdk'
import { defineStore } from 'pinia'
import { ref } from 'vue'

const PRINTER_ALTERNATIVE_CONFIG_GENERIC = {
  Id: 999,
  Name: 'Generic'
}

const useDeviceManagementPrintStore = defineStore('deviceManagementPrintStore', () => {
  const selectedPrinter = ref<DmPrinter>()
  const detectedPrinters = ref<DmDetectedPrinters>([])
  const supportedPrinters = ref<DMSupportedPrinter[]>([])

  const setPrinter = (printer: DmPrinter) => {
    selectedPrinter.value = printer
  }

  const getAlternativePrinterConfigId = (printer: DmPrinter) =>
    supportedPrinters.value.find(({ Name }) => Name.toLowerCase() === printer.model.toLowerCase())
      ?.Id || PRINTER_ALTERNATIVE_CONFIG_GENERIC.Id

  const setDetectedPrinters = (printers: DmDetectedPrinters) => {
    detectedPrinters.value = printers.map((detectedPrinter) => {
      // Check by printer model is added due to Windows OS, where detected printers Id's are always set to 0.
      if (detectedPrinter.printer.id === 0) {
        detectedPrinter.printer.id = getAlternativePrinterConfigId(detectedPrinter.printer)
      }

      return detectedPrinter
    })
  }

  const setSupportedPrinters = (printers: DMSupportedPrinter[]) => {
    supportedPrinters.value = [...printers, PRINTER_ALTERNATIVE_CONFIG_GENERIC]
  }

  return {
    setPrinter,
    setDetectedPrinters,
    setSupportedPrinters,
    getAlternativePrinterConfigId,
    selectedPrinter,
    detectedPrinters,
    supportedPrinters
  }
})

export { useDeviceManagementPrintStore }
